import * as yup from "yup";
import { phoneRegExp } from "../validations/constant";
import { isRequired, invalidFormat, minLength } from "./messages";

export const RegisterValidation = yup.object().shape({
	firstName: yup
		.string()
		.required(isRequired("First Name"))
		.min(2, minLength("First Name", 2))
		.max(50, "First name must be no more than 50 characters"),
	lastName: yup
		.string()
		.required(isRequired("Last Name"))
		.min(2, minLength("Last Name", 2))
		.max(50, "Last name must be no more than 50 characters"),
	company: yup
		.string()
		.required(isRequired("Company"))
		.min(2, minLength("Company", 2))
		.max(100, "Company name must be no more than 100 characters"),
	companyType: yup.string().required("Please select a company type"),
	jobtitle: yup
		.string()
		.required(isRequired("Job Title"))
		.min(2, minLength("Job Title", 2))
		.max(100, "Job title must be no more than 100 characters"),
	city: yup
		.string()
		.required(isRequired("City"))
		.min(2, minLength("City", 2))
		.max(100, "City name must be no more than 100 characters"),
	state: yup
		.string()
		.required(isRequired("State"))
		.min(2, minLength("State", 2))
		.max(100, "State name must be no more than 100 characters"),
	country: yup.string().required(isRequired("Country")),
	phoneNumber: yup
		.string()
		.required(isRequired("Phone Number"))
		.matches(phoneRegExp, invalidFormat("Phone number", "(123) 456-7890 or +1 123 456 7890")),
	email: yup
		.string()
		.required(isRequired("Email"))
		.email("Please enter a valid email address (e.g., name@example.com)")
		.max(255, "Email address is too long"),
	password: yup
		.string()
		.required(isRequired("Password"))
		.min(8, "Password must be at least 8 characters long")
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
			"Password must contain at least one uppercase letter, one lowercase letter, and one number"
		),
	confirmPassword: yup
		.string()
		.required(isRequired("Confirm Password"))
		.oneOf([yup.ref("password"), null], "Passwords do not match. Please ensure both passwords are identical.")
});
